import styled from 'styled-components';

export const StepperWrapper = styled.div`
  @media screen and (max-width: 1000px) {
    display: none;
  }
`;

export const MiniStepperWrapper = styled.div`
  margin-top: 32px;
  display: flex;
  justify-content: center;

  @media (min-width: 767px) {
    display: none;
  }
`;
